import { doorClient, ImResponse, resolve } from '.';
import { UpdateVoucherStatusBody } from './conversation';

export enum OperationType {
  End = 'end',
  Suspend = 'suspend',
  Resume = 'resume',
}

export enum VoucherType {
  // 店铺券
  Shop = 1,
  // 商品券
  Product,
}

// 折扣类型
export enum RewardType {
  // 固定金额折扣
  FixAmount = 1,
  // 百分比优惠
  DiscountPercentage,
  // 百分比返现(Shopee币回扣)
  CoinCashback,
}

// 优惠券状态
export enum VoucherStatus {
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED',
  Ended = 'ENDED',
}

export enum VoucherDisplayPosition {
  // 为空，表示仅通过优惠码发放
  // 所有页面
  AllPage = 1,
  // 订单页面
  OrderPage,
  // 动态
  Dynamic,
  // 直播页面
  LivePage,
}

export interface VoucherBody {
  // 内部店铺ID
  internalStoreId: number;
  // 优惠券码
  voucherCode: string;
  // 优惠券名称
  voucherName: string;
  // 折扣类型，参考RewardType
  rewardType: RewardType;
  // 优惠券类型，参考VoucherType
  voucherType: VoucherType;
  // 可领取数量
  usageQuantity: number;
  // 减免的固定金额，仅当reward_type=1
  discountAmount: number;
  // 减免的百分比,50.0代表减免50%
  percentage: number;
  // 优惠券生效时间 秒值
  startTime: number;
  // 优惠券结束时间 秒值
  endTime: number;
  // 优惠券门槛金额
  minBasketPrice: number;
  // 最大优惠金额，仅当reward_type=2或3
  maxPrice: number;
  // 商品ID列表，数组类型
  itemIdList: number[];
  // 展示位置，仅shopee lazada，参考VoucherDisplayPosition，列表为空，表示仅通过优惠码发放(lazada指线下)
  displayChannelList: VoucherDisplayPosition[];
  // 提前查看时间/提前领取时间，秒值
  displayCollectStartTime: number;
  // 操作人 --新增
  operatorId: number;
  // 每人领取张数，lazada使用
  perCustomerLimit: number;
  language: UpdateVoucherStatusBody['language'];
}

export const createVoucher = (body: VoucherBody) => {
  return doorClient.put<ImResponse>(`/voucher`, body);
};

export const updateVoucher = (body: VoucherBody) => {
  return doorClient.post<ImResponse>(`/voucher`, body);
};

export const checkVoucherCode = (params: { internalStoreId: string; voucherCode: string }) => {
  return resolve(
    doorClient.get<ImResponse<boolean>>(`/voucher/code/check-duplicate`, {
      params,
    }),
  );
};
